<template>
  <div>
    <b-card-body>
      <b-card class="user-password">
        <b-form submit.stop.prevent="save">
          <!-- <p><b>Simulador - Configuração de comunicação</b></p>
          <BR /> -->
          <b-row>
            <b-col sm="12">
              <b-form-group :label="$t('tempo-de-ociosidade-em-minutos')" :label-for="$t('ociosidade')">
                <b-form-input
                  class="input-pentagro"
                  id="ociosidade"
                  type="number"
                  v-model="config.downtime" 
                  name="ociosidade"
                  v-validate="{
                    required: true,
                    numeric: true,
                    min_value: 0,
                  }"
                  :state="validateState('ociosidade')"
                  aria-describedby="ociosidade-feedback"
                  :data-vv-as="$t('aderencia-gdi')"
                  :placeholder="$t('informe-a-aderencia-do-gdi')"
                />
                <b-form-invalid-feedback id="ociosidade-feedback">{{
                  veeErrors.first("ociosidade")
                }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="groupBtn">
            <div>
              <img
                src="@/assets/salvar.png"
                :alt="$t('salvar')"
                style="margin-left: 30px;"
                :title="$t('salvar')"
                @click="save"
              />
              <img
                src="@/assets/atualizar.png"
                style="margin-left: 30px;"
                :title="$t('limpar')"
                :alt="$t('limpar')"
                @click="resetForm"
              />
              <img
                id="closeModalPassword"
                class="float-right"
                src="@/assets/sair.png"
                style="margin-left: 30px;"
                :title="$t('sair')"
                :alt="$t('sair')"
                @click="$bvModal.hide('modalIdleTime')"
              />
            </div>
          </b-row>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import axios from "axios";


export default {
  name: "IdleTime",
  computed: mapState(["user"]),
  data: function() {
    return {
      config: {
        downtime: 0,
      },
      backupConfig: {}
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    save() {
      this.$bvModal.hide('modalIdleTime');
      /* eslint-disable */
      this.$validator.validateAll().then(result => {
        if (!result) {
          showError(this.$t('campos-com-preenchimento-obrigatorio'));
          return;
        } else {   
          this.config.downtime = parseFloat(this.config.downtime)
          // console.log("Config: ", this.config);
          axios["post"](`${urlMainAPI}/savesystemconfiguration/`, this.config) //axios ... método chamado por string
            .then(res => {
              // console.log('ConfigAntesResetForm', this.config)
              this.$nextTick(() => {
                this.$validator.reset();
              });
              //this.$toasted.global.defaultSuccess();
              defaultSuccess(res.data);
              this.backupConfig = { ...this.config}
            })
            .catch(() => {
              this.resetForm();
            });
          // }
        }
      });
    },
    loadSystemConfig(){
      const url = `${urlMainAPI}/getsystemconfiguration`
      axios
      .get(url)
      .then(res => {
        this.config = res.data
        this.backupConfig = { ...res.data}
        this.$nextTick(() => {
          this.$validator.reset();
        });
        // console.log('ConfigSimulator', this.config) 
        // console.log('ConfigSimulator - Backup', this.backupConfig) 
      })
    },
    resetForm() {      
      this.$nextTick(() => {
        this.$validator.reset();
      });
      this.reset();    
    },
    reset() {
      this.config.downtime = this.backupConfig.downtime
    }
  },
  created() {
    this.$validator.localize("pt_BR");
    this.loadSystemConfig()
  }
};
</script>

<style scoped>
.user-password {
  max-width: 600px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

img {
  max-height: 35px;
}
</style>
